<ejs-dialog #detailDialog
  [visible]="visible"
  [isModal]="true"
  [showCloseIcon]="true"
  cssClass="modal-lg"
  (close)="close()">
  <ng-template #header>{{ 'i18n.domain.analytics.diagnostic-events.detail-dialog-title' | translate }}</ng-template>
  <ng-template #content>
    @if (event) {
      <div class="diagnostic-event-detail-content">
        <div class="row g-3 mb-4">
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.diagnostic-events.columns.vehicle-id' | translate }}</div>
            <div class="fw-semibold">{{ event.vehicleId }}</div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.diagnostic-events.detail.ecu-id' | translate }}</div>
            <div class="fw-semibold">{{ formatEcuId(event.ecuId) }}</div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.diagnostic-events.detail.event-type' | translate }}</div>
            <div class="fw-semibold">{{ event.eventType }}</div>
          </div>
          <div class="col-6 col-md-3">
            <div class="text-body-secondary small">{{ 'i18n.domain.analytics.diagnostic-events.detail.timestamp' | translate }}</div>
            <div class="fw-semibold">{{ formatDateTime(event.timestamp) }}</div>
          </div>
        </div>

        <section class="mb-4">
          <h6 class="text-uppercase text-body-secondary small mb-2">{{ 'i18n.domain.analytics.diagnostic-events.detail.dtc' | translate }}</h6>
          <pre class="value-json-content">{{ formattedValueJson(event.dtc) }}</pre>
        </section>

        <section class="mb-4">
          <h6 class="text-uppercase text-body-secondary small mb-2">{{ 'i18n.domain.analytics.diagnostic-events.detail.freeze-frame' | translate }}</h6>
          @if (event.freezeFrame) {
            <div class="row g-3 mb-2">
              <div class="col-6 col-md-3">
                <div class="text-body-secondary small">{{ 'i18n.domain.analytics.diagnostic-events.detail.freeze-frame-id' | translate }}</div>
                <div class="fw-semibold">{{ event.freezeFrame.freezeFrameId ?? '—' }}</div>
              </div>
              <div class="col-6 col-md-3">
                <div class="text-body-secondary small">{{ 'i18n.domain.analytics.diagnostic-events.detail.captured-utc' | translate }}</div>
                <div class="fw-semibold">{{ formatDateTime(event.freezeFrame.capturedUtc) }}</div>
              </div>
            </div>
            @if (event.freezeFrame.measurements.length) {
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>{{ 'i18n.domain.analytics.diagnostic-events.detail.measurements.signal' | translate }}</th>
                    <th>{{ 'i18n.domain.analytics.diagnostic-events.detail.measurements.value' | translate }}</th>
                    <th>{{ 'i18n.domain.analytics.diagnostic-events.detail.measurements.unit' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (measurement of event.freezeFrame.measurements; track measurement.signalId) {
                    <tr>
                      <td>{{ signalLabel(measurement) }}</td>
                      <td>{{ measurement.value }}</td>
                      <td>{{ measurement.unit ?? '—' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <div class="text-body-secondary">{{ 'i18n.domain.analytics.diagnostic-events.detail.measurements.empty' | translate }}</div>
            }
          } @else {
            <div class="text-body-secondary">—</div>
          }
        </section>

        <section>
          <h6 class="text-uppercase text-body-secondary small mb-2">{{ 'i18n.domain.analytics.diagnostic-events.detail.additional-data' | translate }}</h6>
          <pre class="value-json-content">{{ formattedValueJson(event.additionalData) }}</pre>
        </section>
      </div>
    }
  </ng-template>
</ejs-dialog>
